export const AccountSelectMenuWrapper = 'block lg:hidden'

export const AccountMenuWrapper = 'hidden lg:flex flex-col'

export const AccountMenuItem =
  'text-20 font-Roboto leading-28 tracking-0 w-full text-left text-black cursor-pointer hover:underline underline-offset-4 pb-4'

export const AccountMenuItemActive = 'underline underline-offset-4'
